import React, { useEffect, useState } from 'react';
import { Box, LinearProgress, Typography } from '@mui/joy';

const AudioLevelIcon = ({ audioData }) => {
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (!audioData || audioData.length === 0) return;

    // Compute RMS of waveform data to represent loudness
    const rms =
      Math.sqrt(
        audioData.reduce((sum, val) => {
          const centered = val - 128;
          return sum + centered * centered;
        }, 0) / audioData.length
      );

    const normalizedLevel = Math.min(Math.round((rms / 128) * 100), 100);
    setLevel(normalizedLevel);
  }, [audioData]);

  return (
    <Box sx={{ width: 200, display: 'flex', alignItems: 'center', gap: 1, py: 2 }}>
      <LinearProgress
        determinate
        value={level}
      />
    </Box>
  );
};

export default AudioLevelIcon;
